import "src/decidim/budgets/projects"
import "src/decidim/budgets/progressFixed"
import "src/decidim/budgets/exit_handler"

// Images
require.context("../images", true)

import "stylesheets/budgets.scss"
